 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		280: 0,
 		278: 0,
 		279: 0,
 		290: 0,
 		340: 0,
 		341: 0,
 		347: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","216":"AddClosedAlertIDUseCase","217":"CreateDeviceUseCase","218":"CreateDomestikaFollowUseCase","219":"CreateJWTUserUseCase","220":"CreateUserLiveSessionUseCase","221":"CurrentUserUseCase","222":"CurrentWithoutRelationshipsUserUseCase","223":"DeleteDeviceUseCase","224":"DeleteFollowUseCase","225":"ENV_CONFIG1","226":"ENV_CONFIG4","227":"ENV_CONFIG5","228":"ENV_CONFIG6","229":"ENV_CONFIG7","230":"FinishUserLiveSessionUseCase","231":"GetAccessTokenUserUseCase","232":"GetAdvanceGDPRStatusUserUseCase","233":"GetAllBlogUseCase","234":"GetAreasCourseUseCase","235":"GetCartCourseUseCase","236":"GetCategoriesCourseUseCase","237":"GetCourseUseCase","238":"GetFinalProjectVideoByCourseIDCourseUseCase","239":"GetGDPRStatusUserUseCase","240":"GetListLiveFeedbackQuestionUseCase","241":"GetListLiveSessionUseCase","242":"GetListLiveStreamUseCase","243":"GetLiveChannelUseCase","244":"GetLiveSessionUseCase","245":"GetOrganizationUseCase","246":"GetPlusPromotionUseCase","247":"GetPostContentBlogUseCase","248":"GetPromotionCodeAlertUseCase","249":"GetPromotionUseCase","250":"GetPubnubCredentialsUseCase","251":"GetSessionDataUserUseCase","252":"GetSimpleUserUseCase","253":"GetSoftwaresCourseUseCase","254":"GetUserAlertUseCase","255":"GetVideoProgressListCourseUseCase","256":"GetVideoSpeedUserUseCase","257":"GetVideoVolumeUserUseCase","258":"LogoutUserUseCase","259":"PathToRegexp","260":"RefreshAccessTokenUserUseCase","261":"RemoveAccessTokenUserUseCase","262":"SearchCourseUseCase","263":"SendHeaderTrackingUseCase","264":"SendLiveFeedbackAnswersUseCase","265":"SendPlayerTrackingUseCase","266":"SendTrackingUseCase","267":"SendVideoProgressCourseUseCase","268":"SetAdvanceGDPRStatusUserUseCase","269":"SetGDPRStatusUserUseCase","270":"SetVideoSpeedUserUseCase","271":"SetVideoVolumeUserUseCase","272":"UpdateLanguageUserUseCase","273":"UpdateLiveSessionUseCase","274":"UpdateVideoAudioAndSubtitlesCourseUseCase","275":"UpdateVideoProgressCourseUseCase","276":"ViewPageTrackingUseCase","346":"vendors~AddClosedAlertIDUseCase","347":"vendors~AmplitudeJS","348":"vendors~SearchCourseUseCase","349":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"015cf5dda55ca9d75ab2","1":"24b80647d7f6d6396b20","2":"dd88ca7edb4f56c5c5d4","3":"a629c56b57b8b7d73fe9","4":"ce7eceb3361ba11ed0d2","5":"8abbb1d3a995b98a6af9","215":"1b49f060042b231bb27f","216":"02eb28f570f7de0d54a7","217":"3b3fed47d2f20803f073","218":"48208df544feb0c9ae95","219":"f4c97473d288306fa945","220":"7229e59864132955e9c2","221":"6ee4cafcedeb49e4eaed","222":"c2b15ed86af65be300a3","223":"76f73f844473e4a00572","224":"654799b6b84d1d1eb523","225":"aeb770b75a2cb69a66b1","226":"d901af1aa46513244f56","227":"3a6b004bb1b25872b35a","228":"5495a1b6dde07742b6d0","229":"3c02c7c8fa58073e1ee5","230":"017edbba9fa75f69e165","231":"5a9ca8250c7ac6fc020f","232":"e4b5edf6aac9c5ad18d5","233":"2b82668a8ec2faea3f4e","234":"88e8137a20d1aa7c6c4c","235":"b1f21332b608e6c852d8","236":"b488f43b8e5313bf6ce3","237":"67e7be8f4e00175ed6c1","238":"9d9ebea9087aca64dc90","239":"4146a9f8c052fbc699aa","240":"3070bf697074d6a49a03","241":"a464b57fd794e91c8702","242":"d22d43a2662b7438d2a3","243":"20cea563287848233604","244":"147d0c85663df1aca5ce","245":"f004ba23faab6e6b5154","246":"11773e31fb62f6739bb4","247":"ba5d344b09de57e8cb0e","248":"6c8fd69eb1adab453b5b","249":"cce79cb0aa30a2413634","250":"d99782666c2a3e66352e","251":"399d5dd698eccce22ed6","252":"cdee595633bc6962b62e","253":"fc7ced3e5060f13b0438","254":"8fca14c2f6650acbe1c4","255":"731e48098eb64679137b","256":"4d321698e54472d3aefe","257":"a4560ff87148e5c3c244","258":"b4312e951e31ef4cb42c","259":"b92ba134fbdcf660f78b","260":"f1e28eb75fc166076a41","261":"b50cc79fc128e5508906","262":"7308d6e5b0e909d07892","263":"faca25c8339abfc5c044","264":"25ad4849c831b1e8acc7","265":"79874e8d3f4992dce0a0","266":"d015d0adfeeb315645e0","267":"d6bf09f1c92c3df66dfb","268":"87a949e216aad208cb3f","269":"312dc90e6e2af05425a0","270":"f5105c81854e54178e27","271":"80503c43bdd766e3a2f3","272":"f5f4090dfb53a6252eb3","273":"ffa42afd76d4701b0a6d","274":"6f6ff52b48e5d31e8a22","275":"e94258fdb8ee6a4b15b7","276":"fc8237bb920abe8f9db7","346":"663b8baa4a8e13c05d43","347":"159ae16001a0cecafa53","348":"d450d1e93362f761e669","349":"1da86a81ccc2100e76ba","416":"586eede2ee7ffc05a6da","418":"5bccf6b7292b9fc8cc6a","419":"f272ee09fca1c73e62b0","637":"b67f3534bd3999ed1407","638":"3b3b8407842ac0017a86","639":"512110ba1d9f3489f589"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2046);
